<div class="container logout">
  @if (backOrRefresh) {
  <div class="row">
    <br />
    <div class="col">
      <nh-alert type="warning" [isOpen]="backOrRefresh">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span>
              {{ "LOGOUT_MESSAGE" | globalTranslate }}
            </span>
          </div>
        </div>
      </nh-alert>
    </div>
  </div>
  }
  <div class="row">
    <div class="col">
      @if (!mobileUser) {
      <h1 class="page-title">{{ "LOGOUT_HEADER" | globalTranslate }}</h1>
      } @if (mobileUser) {
      <h1 class="page-title">
        {{ "LOGOUT_MOBILE_APP_HEADER" | globalTranslate }}
      </h1>
      }
    </div>
  </div>
  <div class="bg-custom">
    @if (!mobileUser) {
    <div class="container manage-benefits">
      <div>
        <div class="mt-3">
          <div class="container col-xs-12 .col-12 text-align">
            <div class="row full-width">
              <div class="col-md-6 col-sm-12">
                <div class="py-4">
                  <b
                    >{{ "LOGOUT_PARA1_LINE1" | globalTranslate }}<br />
                    {{ "LOGOUT_PARA1_LINE2" | globalTranslate }}<br />
                    {{ "LOGOUT_PARA1_LINE3" | globalTranslate }}</b
                  >
                </div>
                <div class="card">
                  <div class="card-body">
                    <button
                      (click)="onNavigate('MP')"
                      class="p-3 btn-bg btn-height"
                    >
                      <span>{{ "LOGOUT_PARA2_LINE1" | globalTranslate }}</span
                      ><br />
                      <span>{{ "LOGOUT_PARA2_LINE2" | globalTranslate }}</span
                      ><br />
                      <span>{{ "LOGOUT_PARA2_LINE3" | globalTranslate }}</span>
                    </button>
                    <img
                      src="../../../assets/images/welcome_page/pp.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="py-4">
                  <b
                    >{{ "LOGOUT_PARA3_LINE1" | globalTranslate }}<br />
                    {{ "LOGOUT_PARA3_LINE2" | globalTranslate }}<br />
                    {{ "LOGOUT_PARA3_LINE3" | globalTranslate }}</b
                  >
                </div>
                <div class="card">
                  <div class="card-body">
                    <button
                      (click)="onNavigate('pp')"
                      class="p-3 btn-bg btn-height"
                    >
                      <span>{{ "LOGOUT_PARA4_LINE1" | globalTranslate }}</span
                      ><br />
                      <span>{{ "LOGOUT_PARA4_LINE2" | globalTranslate }}</span
                      ><br />
                      <span>{{ "LOGOUT_PARA4_LINE3" | globalTranslate }}</span>
                    </button>
                    <img
                      src="../../../assets/images/welcome_page/PartnerHome1.jpeg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  @if (mobileUser) {
  <div>
    <p>{{ "LOGOUT_MOBILE_APP_STATIC" | globalTranslate }}</p>
  </div>
  }
</div>